import { get, isEqual } from 'lodash';
import { transformQueryOut } from '../../common/components/AdvancedSearch/QueryBuilder/utils';
import { getChargersAdvancedSearchConfig } from '../ChargersList/constants';
import ChargersInfo from '../../common/resources/ChargersInfo';
import { emptyQuery, OPERATOR_NAMES } from '../../common/components/AdvancedSearch/QueryBuilder/constants';
import { getConfigurationPayload, TABS } from '../../common/components/AdvancedSearch/utils';

export const setViewMode = (mode) => ({
  type: 'SET_VIEW_MODE',
  mode,
});

export const setChargers = (chargers) => ({
  type: 'SET_FILTERED_CHARGERS',
  chargers,
});

export const setAutoscale = () => ({
  type: 'SET_AUTOSCALE',
});

export const setAutoscaleOff = () => ({
  type: 'SET_AUTOSCALE_OFF',
});

export const openChangerModal = (data) => ({
  type: 'OPEN_CHARGER_MODAL',
  data,
});

export const setDashboardAdvancedSearchFilter = (query) => ({
  type: 'SET_DASHBOARD_FILTER',
  query,
});

export const setMapChargersProps = (payload) => ({
  type: 'SET_MAP_CHARGERS_PROPS',
  payload,
});

export const defaultFilterQuery = {
  id: 'g-query-root',
  combinator: 'AND',
  rules: [],
};

export const getActiveConditionWrapper = () => ({
  operator: 'AND',
  conditions: [
    {
      field: 'condition',
      operator: OPERATOR_NAMES.equals,
      value: 'active',
    },
  ],
});

export const wrapFilterForActiveOnly = (filter) => {
  const wrappedFilter = getActiveConditionWrapper();

  if (filter) wrappedFilter.conditions.push(filter);

  return wrappedFilter;
};

let intervalId = null;
const querying = {};

const makeInterruptChecker = (processId) => {
  querying[processId] = false;

  return () => querying[processId];
};

export const stopWatchChargers = (excludedProcessId) => () => {
  clearInterval(intervalId);
  intervalId = null;
  Object.keys(querying).forEach((processId) => {
    if (excludedProcessId !== processId) querying[processId] = true;
  });
};

export const getChargers = (query, processId, perRequest) => (dispatch, getState) => {
  const {
    advancedSearch: { selectedTab },
  } = getState();

  const isConfigurationTabAvailable = selectedTab?.dashboard === TABS.CONFIGURATION && !isEqual(query, emptyQuery);
  const queryOut = transformQueryOut([query], getChargersAdvancedSearchConfig())[0];
  const filterBy = wrapFilterForActiveOnly(queryOut);

  const payload = {
    filter_by: filterBy || {},
  };

  if (isConfigurationTabAvailable) {
    payload.config_nodes_filter = getConfigurationPayload(queryOut);
    payload.filter_by = getActiveConditionWrapper();
  }

  const isInterrupt = makeInterruptChecker(processId);

  dispatch(
    setMapChargersProps({
      areLoading: true,
      loadedCount: 0,
    }),
  );

  return ChargersInfo.getForMapByChunk({
    queryParams: { sort_by: 'c_uuid', sort_order: 'ASC' },
    bodyParams: payload,
    per: perRequest,
    isInterrupt,
    successResponseHandlerMaker:
      ({ resolve, collectedData, responseDataPath, pathOfTotal }) =>
      (response) => {
        const collected = [...collectedData, ...get(response, responseDataPath, [])];

        dispatch(
          setMapChargersProps({
            loadedCount: collected.length,
            totalCount: get(response, pathOfTotal),
          }),
        );
        resolve(collected);
      },
  }).then((chargers) => {
    if (chargers) dispatch(setChargers(chargers));
    dispatch(setMapChargersProps({ areLoaded: true, areLoading: false }));
  });
};

export const watchChargers = (query, processId) => (dispatch) => {
  dispatch(stopWatchChargers(processId));
  dispatch(getChargers(query, processId));
  dispatch(setAutoscale());
};
